import { createExperiments } from '@cbhq/experiments';

export const workspaceExperimentConfig = {
  t0018_99ac577d: ['control', 'treatment'] as const,
  // workspace_invite_flow_v2
  t0018_79dfabfe: ['control', 'treatment'] as const,
} as const;

const AppExperiments = createExperiments(workspaceExperimentConfig);

export default AppExperiments;
